import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router'
import Axios from 'axios'
import VueAxios from 'vue-axios'
// 隐藏 右侧浏览器 滚动条
// import VueSmoothScroll from "vue2-smooth-scroll";
Vue.use(VueAxios, Axios);
Vue.prototype.websiteUrl = 'https://abc.jzstrong.com:8082'; //客户端ip
// Vue.prototype.websiteUrl = 'https://localhost:44366'; //本地测试地址   /
Vue.use(ElementUI);
// Vue.component('icon', Icon) //注册svg插件

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})

// WEBPACK FOOTER //
// ./src/main.js



// WEBPACK FOOTER //
// ./src/main.js